<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
html,
body {
  font-family: PingFangSC-Regular, 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
* {
  box-sizing: border-box;
}
body,
p,
ul,
li {
  margin: 0;
  padding: 0;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  font-weight: normal;
}
ul,
li {
  list-style: none;
}
a {
  text-decoration: none;
}
html,
body {
  position: relative;
  min-height: 100%;
  width: 100%;
  background-color: #0e0f1a;
}
.ui-toast {
  position: fixed;
  z-index: 9999;
  top: 50%;
  left: 50%;
  color: #fff;
  text-align: center;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 14px;
  background-color: rgba(0, 0, 0, 0.58);
  transition: opacity 0.25s ease-in-out;
  transform: translate(-50%, -50%);
  word-break: break-all;
  opacity: 0;
  &.show {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue